import { todayFeed } from "@/mocks/homeData";

const heatStyles: Record<string, string> = {
  爆: "bg-primary-100 text-primary-700",
  热: "bg-accent-100 text-accent-900",
  新: "bg-secondary-100 text-secondary-800",
};

export default function TodayFeed() {
  return (
    <section id="today" className="w-full px-4 py-10 md:px-8 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[280px_1fr] lg:gap-12">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="font-label text-[11px] tracking-[0.24em] text-secondary-600">TODAY</span>
          <h3 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            今日速递
          </h3>
          <p className="mt-3 font-body text-sm leading-7 text-foreground-700">
            按时间倒序记录今天被反复提起的每一条动态。我们只保留有时间戳、能对上出处的部分。
          </p>
          <div className="mt-5 flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-refresh-line text-base" />
            </span>
            <span className="font-label text-xs text-foreground-700">
              共 <strong className="text-primary-700">6</strong> 条更新 · 每 30 分钟刷新
            </span>
          </div>
        </div>

        <ol className="border-l border-background-200">
          {todayFeed.map((item, idx) => (
            <li key={`${item.time}-${idx}`} className="relative pb-7 pl-6 last:pb-0 md:pl-8">
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full border-2 border-background-50 bg-primary-500" />
              <article className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-200 hover:border-primary-300 md:p-5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                  <time className="font-heading text-sm font-bold text-foreground-950">{item.time}</time>
                  <span className="h-3 w-px bg-background-300" />
                  <span className="font-label text-xs text-secondary-600">{item.channel}</span>
                  {item.heat && (
                    <span
                      className={`rounded-sm px-1.5 py-0.5 font-label text-[11px] font-medium ${heatStyles[item.heat]}`}
                    >
                      {item.heat}
                    </span>
                  )}
                </div>
                <h4 className="mt-2 font-heading text-base font-bold leading-6 text-foreground-950 md:text-[17px]">
                  <a href="#live" className="transition-colors duration-200 hover:text-primary-700">
                    {item.title}
                  </a>
                </h4>
                <p className="mt-2 font-body text-[13px] leading-6 text-foreground-600">{item.note}</p>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}